export default __webpack_public_path__ + "static/hero-portrait-small-ef0185e4bc9b668235f4ffeaaf901707.mp4";